/**  @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import classNames from 'classnames';

import { breakpoints } from '@coursera/cds-core';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';
import type { VideoPlayer as VideoPlayerType } from 'bundles/item-lecture';
import FullscreenExitSvg from 'bundles/video-player/assets/svg/FullscreenExitSvg';
import FullscreenSvg from 'bundles/video-player/assets/svg/FullscreenSvg';
import type { VideoPlayerEventingV3UIFunction } from 'bundles/video-player/types/VideoPlayer';

import _t from 'i18n!nls/video-player';

const styles = {
  fullscreenToggleTooltipWrapper: css`
    ${breakpoints.down('xs')} {
      height: 30px;
      display: flex;
      align-items: center;
    }

    .rc-FullscreenToggle {
      color: #dedede;
    }
  `,
};

type Props = {
  player: VideoPlayerType;
  trackVideoPlayerClickEvent: VideoPlayerEventingV3UIFunction;
};

function IosFullscreenToggle({ player, trackVideoPlayerClickEvent }: Props) {
  const isFullscreen = player.isFullscreen();

  const label = isFullscreen ? _t('Exit full Screen') : _t('Full Screen');

  const handleFullscreenToggle = () => {
    if (isFullscreen) {
      player.exitFullscreen();
    } else {
      player.requestFullscreen();
    }

    trackVideoPlayerClickEvent('video_full_screen', { fullscreen: !isFullscreen });
  };

  const fullscreenSvg = isFullscreen ? (
    <FullscreenExitSvg width={28} height={28} />
  ) : (
    <FullscreenSvg width={28} height={28} />
  );

  return (
    <TooltipWrapper
      className="fullscreen-toggle-tooltip-wrapper"
      placement="top"
      message={label}
      css={styles.fullscreenToggleTooltipWrapper}
    >
      <button
        type="button"
        onClick={handleFullscreenToggle}
        className={classNames(
          'rc-FullscreenToggle',
          'vjs-button',
          'c-vjs-button',
          'vjs-control',
          'c-video-control',
          'c-fullscreen-control',
          'horizontal-box',
          'align-items-absolute-center'
        )}
        aria-label={label}
        aria-expanded={isFullscreen}
      >
        <React.Fragment>{fullscreenSvg}</React.Fragment>

        <span className="vjs-control-text"> {label} </span>
      </button>
    </TooltipWrapper>
  );
}
export default IosFullscreenToggle;
